define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseApiService = require('web-agent-utils/BaseApiService');

    lpTag.EngagementsHistoryExport = function () {
        this.applicationType = "EngagementsHistoryExport";
        var logger = WebAgentLogger.getLogger(this.applicationType);

        var engagementHistoryExportResource = agentLEManager.getLEUrlResolverApiResourcesService(this.applicationType);
        var exportResourceAdditionalUrl;

        if (engagementHistoryExportResource && engagementHistoryExportResource.Export && engagementHistoryExportResource.Export.url) {
            var fullResourceUrl = agentLEManager.getLEUrlResolverGetUrl(engagementHistoryExportResource.Export.url);
            var resourceDomainUrl = lpUtils.getSubDomain(fullResourceUrl);
            exportResourceAdditionalUrl = fullResourceUrl.substring(resourceDomainUrl.length);
            engagementHistoryExportResource = BaseApiService.createInstance({domainUrl: resourceDomainUrl, serviceName: this.applicationType});
        }

        this.exportEngagements = function (reqObj) {
            reqObj.callingFunction = 'exportEngagements';
            reqObj.method = 'GET';
            reqObj.additionalUrl = exportResourceAdditionalUrl;
            reqObj.timeout = 20000;

            engagementHistoryExportResource.sendDownloadRequest(reqObj);

        };

    };

    return lpTag.EngagementsHistoryExport;

});
